export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          投稿爆料
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-500"></i>
            </div>
            <h3 className="text-lg font-heading text-foreground-950 mb-3">有料你就来！</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              如果你有独家爆料、幕后故事或娱乐资讯线索，欢迎通过以下方式联系我们。
              我们承诺严格保护投稿人隐私，优质爆料一经采用即付丰厚稿酬。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-mail-line text-primary-500"></i>
                <span>tips@baogua.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-wechat-line text-accent-500"></i>
                <span>爆瓜网官方微信</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}